<script>
import { storeToRefs } from 'pinia';
import { useVisitStore } from '../../../store/contact/VisitStore';

export default {
    setup() {
        const store = useVisitStore();
        const { submit, prevStep } = store;
        return {
            submit,
            prevStep,
        };
    },
    data() {
        return {
            agreement: false,
        }
    }
};
</script>
<template>
    <div class="tw-w-full mb-50px contact-us__agreement-container">
        <input class="form-check-input" type="checkbox" id="agreementCHK" v-model="agreement" />        
        <label for="agreementCHK" class="fs-16px tw-text-darkGreen">
            By clicking on the button below, I give my consent to Ortigas & Company Limited Partnership (OCLP) and to its subsidiaries, affiliates, partners, successors and assigns, and to their service providers and agents, to collect, possess, use, store and disclose any and all information and personal data furnished herein, or as may otherwise be provided by me, for the purpose of providing me information on their products and services, including but not limited to, offers, promotions, and new goods and services.
        </label>
    </div>
    <div
        class="tw-flex tw-w-full tw-flex-col-reverse tw-items-center lg:tw-flex-row"
    >
        <div class="back-button-wrapper mt-40px mt-0px-lg lg:tw-w-1/2">
            <a
                href="/contact-us"
                class="fs-14px fw-semibold tw-text-accentGreen hover:tw-text-accentGreen"
            >
                BACK TO START
            </a>
        </div>

        <div class="buttons-wrapper lg:tw-w-1/2 tw-w-[inherit]">
            <div class="prev-button tw-w-[88px]" @click="prevStep">
                <i aria-hidden="true" class="fa fa-chevron-left fw-bold"></i>
            </div>
            <div
                :class="agreement ? 'submit-inquiry__enabled' : 'submit-inquiry__disabled'"
                class="tw-cursor-pointer tw-uppercase tw-bg-accentGreen tw-text-white tw-text-[14px] tw-w-[284px] tw-text-center tw-tracking-[2px] tw-flex tw-items-center tw-justify-center"
                @click="submit"
            >
                SUBMIT INQUIRY
            </div>
        </div>
    </div>
</template>
